module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/sidebar-shield-inactive.8f21e72b.svg";